<div class="header">
	<h2>Gebruikers</h2>
</div>
<div class="search-header">
	<app-instant-search-box (fire)="searchInput$.next($event)" placeholder="Gebruiker zoeken"></app-instant-search-box>
</div>
<div class="content">
	@if (accounts$ | async; as accounts) {
		@if (accounts.length > 0) {
			<table>
				<thead>
					<tr>
						<th>Naam</th>
						<th>Afkorting</th>
						<th>Instelling</th>
						<th>Rollen</th>
						<th>E-mail</th>
					</tr>
				</thead>
				<tbody>
					@for (account of accounts; track account.id; let odd = $odd; let even = $even) {
						<tr (click)="gotoInstelling(account)" [class.odd]="odd" [class.even]="even">
							<td>
								<span>{{ account.naam }}</span>
							</td>
							<td>
								<span>{{ account.afkorting }}</span>
							</td>
							<td>
								<span>{{ account.instelling.naam }}</span>
							</td>
							<td>
								<span>{{ rollenShort(account.rollen) }}</span>
							</td>
							<td>
								<span>{{ account.email }}</span>
							</td>
						</tr>
					}
				</tbody>
			</table>
		} @else if ((searchInput$ | async)?.trim()) {
			<p class="message">Geen gebruikers gevonden.</p>
		} @else {
			<p class="message">Gebruik het zoekveld om gebruikers te zoeken binnen alle instellingen.</p>
		}
	}
</div>
